export const profitability: Record<string, string> = {
  // Navigation. Reached through navItems, so check:i18n cannot see these two.
  'Performance, workload and contract margins': 'Performance, charge de travail et marges par contrat',
  'Cost and margin per client contract': 'Coût et marge par contrat client',

  // Page header and period
  'Profitability': 'Rentabilité',
  'Cost and margin per contract': 'Coût et marge par contrat',
  'The roster for the period, priced with the pay rules payroll uses at the rates in force today, and set against what each client is charged.':
    'Le planning de la période, chiffré avec les règles de paie utilisées par la paie aux taux en vigueur aujourd’hui, et comparé à ce qui est facturé à chaque client.',
  'Last 4 weeks': '4 dernières semaines',
  'Next 4 weeks': '4 prochaines semaines',
  'Last 13 weeks': '13 dernières semaines',
  '{start} to {end}': 'Du {start} au {end}',
  '{count} rostered shift': '{count} vacation planifiée',
  '{count} rostered shifts': '{count} vacations planifiées',
  '{count} still a draft': '{count} encore en brouillon',
  '{count} still drafts': '{count} encore en brouillon',
  'Could not load profitability.': 'Impossible de charger la rentabilité.',
  'Nothing is rostered in this period.': 'Rien n’est planifié sur cette période.',
  'Margins are worked out from the duty board. Choose another period, or roster some shifts.':
    'Les marges sont calculées à partir du tableau de service. Choisissez une autre période ou planifiez des vacations.',

  // Notices
  'These margins use starting assumptions: employer on-costs of {onCost} of pay and a target margin of {target}. Set your own under Assumptions.':
    'Ces marges reposent sur des hypothèses de départ : des charges patronales de {onCost} de la rémunération et une marge cible de {target}. Définissez les vôtres dans Hypothèses.',
  '{count} client has no charge rate for these shifts, so no margin can be stated for it. {amount} of labour cost is outside the figures below.':
    '{count} client n’a pas de taux de facturation pour ces vacations ; aucune marge ne peut donc être indiquée pour lui. {amount} de coût de main-d’œuvre ne figurent pas dans les chiffres ci-dessous.',
  '{count} clients have no charge rate for these shifts, so no margin can be stated for them. {amount} of labour cost is outside the figures below.':
    '{count} clients n’ont pas de taux de facturation pour ces vacations ; aucune marge ne peut donc être indiquée pour eux. {amount} de coût de main-d’œuvre ne figurent pas dans les chiffres ci-dessous.',
  '{count} shift is priced at the company base rate because its guard has no pay band or rank rate.':
    '{count} vacation est chiffrée au taux de base de l’entreprise, car son agent n’a ni grille de rémunération ni taux de grade.',
  '{count} shifts are priced at the company base rate because their guards have no pay band or rank rate.':
    '{count} vacations sont chiffrées au taux de base de l’entreprise, car leurs agents n’ont ni grille de rémunération ni taux de grade.',

  // Headline figures
  'Totals for priced contracts': 'Totaux des contrats facturés',
  'Revenue': 'Chiffre d’affaires',
  '{hours} billable hours': '{hours} heures facturables',
  'Labour cost': 'Coût de main-d’œuvre',
  '{pay} pay + {onCost} on-costs': '{pay} de rémunération + {onCost} de charges',
  'Margin': 'Marge',
  'Needs attention': 'À surveiller',
  '{loss} loss-making · {below} below target': '{loss} déficitaires · {below} sous l’objectif',

  // Statuses
  'Loss-making': 'Déficitaire',
  'Below target': 'Sous l’objectif',
  'On target': 'Objectif atteint',
  'No charge rate': 'Pas de taux de facturation',
  'Turns loss-making': 'Devient déficitaire',
  'Already loss-making': 'Déjà déficitaire',
  'Falls below target': 'Passe sous l’objectif',
  'Still below target': 'Toujours sous l’objectif',
  'Stays on target': 'Reste à l’objectif',
  'Sites without a client': 'Sites sans client',

  // Scenario
  'Model a pay increase': 'Simuler une hausse de rémunération',
  'Today nobody is paid under {rate} an hour. Try the next minimum and see which contracts it turns.':
    'Aujourd’hui, personne n’est payé moins de {rate} de l’heure. Essayez le prochain minimum et voyez quels contrats basculent.',
  'Try the next minimum hourly rate and see which contracts it turns.':
    'Essayez le prochain taux horaire minimum et voyez quels contrats basculent.',
  'New minimum hourly rate': 'Nouveau taux horaire minimum',
  'New unsocial-hours premium (optional)': 'Nouvelle prime d’heures atypiques (facultatif)',
  'Unchanged': 'Inchangée',
  'Quick increases': 'Hausses rapides',
  'Staff paid above the minimum keep the same gap over it': 'Le personnel payé au-dessus du minimum conserve le même écart',
  'Off: only people below the new minimum are raised to it.':
    'Désactivé : seules les personnes sous le nouveau minimum y sont relevées.',
  'Enter a rate to see what it does to each contract.': 'Saisissez un taux pour voir son effet sur chaque contrat.',
  'At {rate} an hour, {count} contract that makes money today would lose it.':
    'À {rate} de l’heure, {count} contrat rentable aujourd’hui deviendrait déficitaire.',
  'At {rate} an hour, {count} contracts that make money today would lose it.':
    'À {rate} de l’heure, {count} contrats rentables aujourd’hui deviendraient déficitaires.',
  'At {rate} an hour no contract turns loss-making, but {count} falls below your target margin.':
    'À {rate} de l’heure, aucun contrat ne devient déficitaire, mais {count} passe sous votre marge cible.',
  'At {rate} an hour no contract turns loss-making, but {count} fall below your target margin.':
    'À {rate} de l’heure, aucun contrat ne devient déficitaire, mais {count} passent sous votre marge cible.',
  'At {rate} an hour nothing changes: nobody on this roster is paid less than that.':
    'À {rate} de l’heure, rien ne change : personne sur ce planning n’est payé moins que cela.',
  'At {rate} an hour every priced contract keeps the margin status it has today.':
    'À {rate} de l’heure, chaque contrat facturé conserve son niveau de marge actuel.',
  'Labour cost over the period moves by {change}; the margin across priced contracts goes from {before} to {after}.':
    'Le coût de main-d’œuvre sur la période varie de {change} ; la marge sur les contrats facturés passe de {before} à {after}.',
  '{count} contract is loss-making already.': '{count} contrat est déjà déficitaire.',
  '{count} contracts are loss-making already.': '{count} contrats sont déjà déficitaires.',

  // Table
  'Margin by client': 'Marge par client',
  'Worst first. Open a client to see its sites, where the labour cost goes and the case for a new rate.':
    'Du moins rentable au plus rentable. Ouvrez un client pour voir ses sites, la répartition du coût de main-d’œuvre et l’argumentaire pour un nouveau taux.',
  'Billable hours': 'Heures facturables',
  'Charged / hour': 'Facturé / heure',
  'Cost / hour': 'Coût / heure',
  'Margin today': 'Marge actuelle',
  'Before {date}': 'Avant le {date}',
  'At {rate}': 'À {rate}',
  'Charge rise needed': 'Hausse du taux nécessaire',
  '{rate} holds the margin': '{rate} maintient la marge',
  '{rate} reaches the target': '{rate} atteint l’objectif',
  'Set charge rate': 'Définir le taux de facturation',
  'None': 'Aucune',

  // Expanded client
  'Where the labour cost goes': 'Répartition du coût de main-d’œuvre',
  'Base pay': 'Rémunération de base',
  'Overtime premium': 'Majoration des heures supp.',
  'Sunday premium': 'Majoration du dimanche',
  'Public holiday premium': 'Majoration des jours fériés',
  'Unsocial-hours premium': 'Prime d’heures atypiques',
  'Minimum shift payment': 'Rémunération minimale par vacation',
  'Employer on-costs': 'Charges patronales',
  'The case for this client': 'L’argumentaire pour ce client',
  'Add what this client is charged per hour and the margin appears here.':
    'Ajoutez le tarif horaire facturé à ce client et la marge s’affichera ici.',
  'These sites belong to no client. Give them one on the Sites page to set a charge rate.':
    'Ces sites ne sont rattachés à aucun client. Attribuez-leur un client depuis la page Sites pour définir un taux de facturation.',
  '{client}: {hours} billable hours from {start} to {end}.':
    '{client} : {hours} heures facturables du {start} au {end}.',
  'Charged {charge} an hour; labour costs {cost} an hour. Margin {margin} ({percent}).':
    'Facturé {charge} de l’heure ; la main-d’œuvre coûte {cost} de l’heure. Marge {margin} ({percent}).',
  'Before the minimum rose to {rate} on {date}, the margin was {percent}.':
    'Avant le passage du minimum à {rate} le {date}, la marge était de {percent}.',
  'At a minimum of {rate} an hour, labour would cost {cost} an hour and the margin would be {percent}.':
    'Avec un minimum de {rate} de l’heure, la main-d’œuvre coûterait {cost} de l’heure et la marge serait de {percent}.',
  'A charge rate of {rate} ({rise}) would keep the margin where it is today.':
    'Un taux de facturation de {rate} ({rise}) maintiendrait la marge à son niveau actuel.',
  'Reaching a {target} margin would take a charge rate of {rate} ({rise}).':
    'Atteindre une marge de {target} demanderait un taux de facturation de {rate} ({rise}).',
  'Charge rates': 'Taux de facturation',
  'Copy summary': 'Copier le résumé',
  'Summary copied': 'Résumé copié',
  'Could not copy to the clipboard.': 'Impossible de copier dans le presse-papiers.',

  // Assumptions
  'Assumptions': 'Hypothèses',
  'Employer on-costs are what employing somebody costs on top of gross pay: employer social insurance, holiday pay, pension, uniform. They rise with pay, so a pay increase raises them too.':
    'Les charges patronales représentent ce que coûte un salarié en plus de sa rémunération brute : cotisations sociales patronales, congés payés, retraite, uniforme. Elles augmentent avec la rémunération : une hausse de salaire les fait donc augmenter aussi.',
  'Employer on-costs (% of gross pay)': 'Charges patronales (% de la rémunération brute)',
  'Target margin (% of revenue)': 'Marge cible (% du chiffre d’affaires)',
  'Save assumptions': 'Enregistrer les hypothèses',
  'Assumptions saved': 'Hypothèses enregistrées',
  'Employer on-costs must be between 0% and 200% of pay.':
    'Les charges patronales doivent être comprises entre 0 % et 200 % de la rémunération.',
  'Target margin must be at least 0% and under 100%.':
    'La marge cible doit être d’au moins 0 % et inférieure à 100 %.',

  // Charge-rate dialog
  'Charge rates for {client}': 'Taux de facturation de {client}',
  'What this client pays for an hour of cover. A rate set for one site replaces the client rate at that site.':
    'Ce que ce client paie pour une heure de couverture. Un taux défini pour un site remplace le taux du client sur ce site.',
  'Applies to': 'S’applique à',
  'Every site': 'Tous les sites',
  'Every site of this client': 'Tous les sites de ce client',
  'From {from}': 'À partir du {from}',
  '{from} to {to}': 'Du {from} au {to}',
  'No charge rate recorded for this client yet.': 'Aucun taux de facturation enregistré pour ce client.',
  'Remove this rate': 'Supprimer ce taux',
  'Remove this rate. The rate before it runs on in its place.':
    'Supprimer ce taux. Le taux précédent continue de s’appliquer à sa place.',
  'Hourly charge rate': 'Taux horaire facturé',
  'Sunday multiplier': 'Coefficient du dimanche',
  'Public holiday multiplier': 'Coefficient des jours fériés',
  'Save rate': 'Enregistrer le taux',
  'A new rate closes the one it replaces the day before. Saving the same date again corrects that rate.':
    'Un nouveau taux clôt la veille celui qu’il remplace. Enregistrer de nouveau la même date corrige ce taux.',
  'Enter the hourly charge rate.': 'Saisissez le taux horaire facturé.',
  'Enter a multiplier of 0 or more. 1 charges those hours at the plain rate.':
    'Saisissez un coefficient de 0 ou plus. 1 facture ces heures au taux normal.',
  'Choose the date the rate applies from.': 'Choisissez la date d’application du taux.',

  // CSV columns
  'Charge rate': 'Taux de facturation',
  'Paid hours': 'Heures payées',
  'Cost per billable hour': 'Coût par heure facturable',
  'Margin %': 'Marge %',
  'Scenario labour cost': 'Coût de main-d’œuvre du scénario',
  'Scenario margin': 'Marge du scénario',
  'Scenario margin %': 'Marge du scénario %',
  'Charge rise to hold margin %': 'Hausse du taux pour maintenir la marge %',

  // Pay flags on the duty board
  'Pay flags': 'Alertes de paie',
  '{count} shift will cost more than its hours if published as it stands.':
    '{count} vacation coûtera plus que ses heures si elle est publiée en l’état.',
  '{count} shifts will cost more than their hours if published as they stand.':
    '{count} vacations coûteront plus que leurs heures si elles sont publiées en l’état.',
  '{count} shift on this roster costs more than its hours.':
    '{count} vacation de ce planning coûte plus que ses heures.',
  '{count} shifts on this roster cost more than their hours.':
    '{count} vacations de ce planning coûtent plus que leurs heures.',
  'That adds {amount} to a day of {total}.': 'Cela ajoute {amount} à une journée de {total}.',
  'Show shifts': 'Afficher les vacations',
  'Hide shifts': 'Masquer les vacations',
  'Double time': 'Heures doublées',
  'Below the statutory minimum rate': 'Sous le taux minimum légal',
  'Paid {duration} more than rostered to reach the minimum shift':
    '{duration} payées en plus du planning pour atteindre la vacation minimale',
  '{duration} in unsocial hours': '{duration} en heures atypiques',
  '{duration} on a Sunday': '{duration} un dimanche',
  '{duration} on a public holiday ({holiday})': '{duration} un jour férié ({holiday})',
  '{duration} on a public holiday': '{duration} un jour férié',
  '{duration} of overtime': '{duration} d’heures supplémentaires',
  '{duration} at double time': '{duration} en heures doublées',
  'Pay band rate is under the statutory minimum and is lifted to it':
    'Le taux de la grille est inférieur au minimum légal et y est relevé',
  '{hours}h': '{hours} h',
  '{minutes}m': '{minutes} min',

  // Irish public holidays. Named by the payroll calendar and reached through a variable.
  'New Year': 'Jour de l’An',
  'First Monday in February': 'Premier lundi de février',
  "St Patrick's Day": 'Saint-Patrick',
  'Easter Monday': 'Lundi de Pâques',
  'First Monday in May': 'Premier lundi de mai',
  'First Monday in June': 'Premier lundi de juin',
  'First Monday in August': 'Premier lundi d’août',
  'Last Monday in October': 'Dernier lundi d’octobre',
  'Christmas Day': 'Jour de Noël',
  "St Stephen's Day": 'Saint-Étienne',
};
